import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProductosMasVendidos,
  setProductosMasVendidos,
  deleteProductosMasVendidos,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* PRODUCTOS_MAS_VENDIDOS_LOAD(action) {
  try {
    const response = yield call(getProductosMasVendidos, action.payload)
    if (response.ok) {
      yield put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_LOAD_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* PRODUCTOS_MAS_VENDIDOS_INSERT(action) {
  try {
    const response = yield call(setProductosMasVendidos, action.payload)
    if (response.ok) {
      putMessage(messageType.SUCCESS, 'Insertado correctamente')
      yield put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_INSERT_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al insertar')
      yield put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al insertar')
    yield all([
      put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PRODUCTOS_MAS_VENDIDOS(action) {
  try {
    const productoResult = yield call(deleteProductosMasVendidos, action.payload)
    if (productoResult.ok) {
      putMessage(messageType.SUCCESS, 'Eliminado correctamente')
      yield put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar')
      yield put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar')
    yield all([
      put({
        type: actions.PRODUCTOS_MAS_VENDIDOS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PRODUCTOS_MAS_VENDIDOS_LOAD_REQUESTED, PRODUCTOS_MAS_VENDIDOS_LOAD),
    takeEvery(actions.PRODUCTOS_MAS_VENDIDOS_INSERT_REQUESTED, PRODUCTOS_MAS_VENDIDOS_INSERT),
    takeEvery(actions.PRODUCTOS_MAS_VENDIDOS_DELETE_REQUESTED, DELETE_PRODUCTOS_MAS_VENDIDOS),
  ])
}
